import { useRef } from "react";
import { useTheme } from "./ThemeProvider";
import { Moon, Sun } from "lucide-react";

type ThemeToggleProps = {
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
};

export function ThemeToggle({
  className = "",
  buttonClassName = "rounded-xl transition-colors",
  iconClassName = "h-5 w-5"
}: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    if (!buttonRef.current) return;

    // Get the button's position relative to the viewport
    const { top, left, width, height } = buttonRef.current.getBoundingClientRect();
    
    // Calculate the center of the button
    const x = left + width / 2;
    const y = top + height / 2;
    
    // Pass the coordinates to the toggleTheme function
    toggleTheme({ x, y });
  };

  return (
    <div className={`flex items-center ${className}`}>
      <button
        ref={buttonRef}
        onClick={handleClick}
        className={`cursor-pointer ${buttonClassName}`}
        aria-label="Toggle theme"
      >
        {theme === "light" ? (
          <Sun className={iconClassName} />
        ) : (
          <Moon className={iconClassName} />
        )}
        <span className="sr-only">Toggle theme</span>
      </button>
    </div>
  );
}